<template>
  <section id="home">
    <div>
        <Searchbar></Searchbar>
        <DbOutput />
      <div v-if="this.$store.state.selectedPersonCard !== 0 || this.$store.state.selectedCompanyCard !== 0">
        <div v-if="this.$store.state.selectedPersonCard !== 0" class="wrap-modal">
          <Person/>
        </div>
        <div v-if="this.$store.state.selectedCompanyCard !== 0" class="wrap-modal">
          <Company/>
        </div>
      </div>
      <div v-else-if="this.$store.state.selectedFilmCard !== 0" class="wrap-modal">
        <Modal/>
      </div>
    </div>
  </section>
</template>
<script>

import DbOutput from '../components/DbOutput.vue';
import Searchbar from '../components/Searchbar.vue';
import Modal from '../components/Modal.vue';
import Person from '../components/Person.vue';
import Company from '../components/Company.vue';

export default {
  components: {
    DbOutput,
    Searchbar,
    Modal,
    Person,
    Company,
  },
};

</script>
